import { Link } from "react-router-dom";
import { Pencil } from "lucide-react";
import { SaveBar } from "@/features/identity/components/SaveBar";
import { useCardEditor } from "@/features/cards/hooks/useCardEditor";
import { CardEditor, CardLoadState, isCardEditorReady } from "@/features/cards/components/CardEditor";
import { ROUTES } from "@/constants/routes";

const STATUS_LABEL = { published: "Published", archived: "Archived" };

function Header({ card }) {
  return (
    <header className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <p className="mw-eyebrow">My Card</p>
        <div className="mt-3 flex flex-wrap items-center gap-3">
          <h1 className="font-serif text-4xl tracking-tight sm:text-5xl">Your digital card.</h1>
          <span data-testid="card-status-badge" className="rounded-full border border-gold/40 bg-gold/5 px-3 py-1 font-mono text-[11px] uppercase tracking-[0.18em] text-gold">
            {STATUS_LABEL[card?.status] || "Draft"}{card ? "" : " · not saved"}
          </span>
        </div>
      </div>
      <Link to={ROUTES.profileEditor} data-testid="card-edit-identity-link" className="mw-btn mw-btn-ghost self-start sm:self-auto">
        <Pencil className="h-4 w-4" /> Edit identity
      </Link>
    </header>
  );
}

export default function CardEditorPage() {
  const editor = useCardEditor();
  if (!isCardEditorReady(editor)) return <CardLoadState editor={editor} />;

  const footer = (
    <div className="rounded-lg border border-border bg-card px-5 py-4">
      <SaveBar status={editor.status} dirty={editor.dirty} onSave={editor.save} testId="card" label="Save draft" />
    </div>
  );
  return (
    <div data-testid="card-editor-page" className="mw-rise space-y-8">
      <Header card={editor.card} />
      <CardEditor editor={editor} footer={footer} />
    </div>
  );
}
